import { SelectItemProps, SelectListPosition } from '../select/types';
import CheckboxInput from '../checkbox/checkbox';
import { SelectComponentProps } from './types';
import IconLoader from '../icons/loader';

import styles from './autocomplete-multiple.module.css';

export default function OptionsList({
  list = [],
  handleSelectValue,
  selectValues,
  selectListPosition,
  contentButtons,
  ulRef,
  onScroll,
  isLoading,
  nextPageIsLoading,
  optionListClassName,
}: SelectComponentProps): React.JSX.Element {
  const isSelectedItem = (item: string) =>
    Boolean(
      selectValues?.find((selectedItem) => selectedItem.toString() === item),
    );

  return (
    <div
      className={`${styles.selectListWrapper} ${
        selectListPosition === SelectListPosition.BOTTOM
          ? styles.bottomPosition
          : styles.topPosition
      } ${optionListClassName || ''}`}
    >
      <ul
        className={`${styles.selectList} ${
          list.length && contentButtons ? styles.withButtons : ''
        }`}
        role="menu"
        ref={ulRef}
        onScroll={onScroll}
      >
        {isLoading && !nextPageIsLoading && (
          <li className={styles.listLoader}>
            <IconLoader />
          </li>
        )}
        {list.length ? (
          list?.map((item: SelectItemProps) => (
            <li key={item.value.toString()} role="menuitem">
              <div className={styles.selectItemTop}>
                <CheckboxInput
                  checked={isSelectedItem(item.value.toString())}
                  type="checkbox"
                  name={item.value.toString()}
                  title={item.name}
                  onChange={() => handleSelectValue(item)}
                  visualClassName={`${styles.checkboxLabel} ${
                    isSelectedItem(item.value.toString())
                      ? styles.checkboxSelectedLabel
                      : ''
                  }`}
                  tabIndex={-1}
                />
                <span className={styles.selectItemTopRight}>
                  <span>{item.suffix || ''}</span>
                </span>
              </div>
            </li>
          ))
        ) : (
          <li role="menuitem">
            <div className={styles.emptyListItem}>Not found</div>
          </li>
        )}
        {nextPageIsLoading && (
          <li className={styles.nextPageLoader}>
            <IconLoader />
          </li>
        )}
      </ul>
      {list.length && contentButtons ? contentButtons : ''}
    </div>
  );
}
